var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    { staticClass: "btn_schedule_add", on: { click: _vm.onClick } },
    [
      _c("span", { staticClass: "ico_cafe ico_plus" }, [
        _vm._v("스케줄 추가하기")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }